import { gql } from '@apollo/client'

export const DELETE_ONE_NOTE = gql`
  mutation deleteOneNote($noteId: String!) {
    deleteOneNote(noteId: $noteId)
  }
`
